module.exports = __webpack_public_path__ + "img/but8.f5c153f2.png";